export default __webpack_public_path__ + "static/media/landing.a9db0f8f.jpg";